module.exports = __webpack_public_path__ + "img/fullsizeoutput_9a4b.6711b649.6711b649.jpeg";